import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";

import { Svg } from '../../1_Atoms/Svg/Svg';
import PropTypes from 'prop-types';

export const PreOrderModal = ({modalContent, isOpen, modalId, handleClose, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const { t } = useTranslation(['summary', 'general']);

    React.useEffect(() => {
        if(isOpen){        
            // Skip if this is the first time loading it because App.js takes care of it.
            //redraw on dealer id change
            if (window.isReactFormsAppLoaded && typeof window.initReactFormsApp === 'function') {
                window.initReactFormsApp();
            }
        }
    }, [isOpen]);

    window.addEventListener("message", function (e) { 
        if (e.data.type === "formEvent") {
           if(e.data.origin === 'preOrder'){
                sessionStorage.setItem('preorder',  e.data.message.dealer_code);
                //handlePreOrderClick();
           }

        }
    });

    return (
        <div className="mz-modal modal" id="preorderModal" aria-hidden={!isOpen}>
            <div className="wrapper">
                <div className="mz-modal__container">
                    <div className="mz-modal__content">
                        <button className="mz-modal__close" aria-label="Close Modal" onClick={() => {
							document.querySelector('body').classList.remove('disabled');
							handleClose(false)
						}}>
                            <Svg
                                colour="grey"
                                size={1.93}
                                svg_list="x"
                            />
                        </button>
                        <div className="mz-modal__text-container">
                            {isOpen &&
                                <>  
                                    <div className="mz-container">
                                        <div className="mz-full-width">
                                            <h3 style={{'paddingTop':'50px'}}>{t('general:pre_order')}</h3>
                                        </div>
                                    </div>
                                    <div className="mzReactForms">
                                        <input type="hidden" data-mz-form-field-name="formType" value="PreOrder" />
                                        <input type="hidden" data-mz-form-field-name="isPreorderModal" value="true"/>
                                        <input type="hidden" data-mz-form-field-name="modelCode" value={summaryCalculator.selectedVehicle.model}/>
                                        <input type="hidden" data-mz-form-field-name="modelOption" value={summaryCalculator.selectedVehicle.packageCode}/>
                                        {sessionStorage.getItem('preorder') &&
                                            <>
                                                <input type="hidden" data-mz-form-field-name="dealerId" value={sessionStorage.getItem('preorder')}/>
                                            </>
                                        }
                                        <input type="hidden" data-mz-form-field-name="source" value="WR" />
                                        <input type="hidden" data-mz-form-field-name="formDisclaimer" value={t("form_disclaimer_retailer")}/>
                                        <div className="mz-react-forms-root"></div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PreOrderModal.propTypes = {
    HandleTabClick: PropTypes.func,
}

PreOrderModal.defaultProps = {
    handleClose: () => {
    },
};